// Building the document model for a learner's pack, and turning it into the A4 PDF.
// jsPDF and the renderer are loaded only when someone asks for the PDF.
import { buildDoc } from '@/canvas/docmodel';

export function buildPackModel({ states, agg, learner }) {
  return buildDoc({ states, agg, learner, generatedOn: new Date().toISOString() });
}

const slug = (s) =>
  String(s || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export function pdfFileName(learner, draft) {
  const who = slug(learner?.name) || 'learner';
  return `AICX-Canvases-${who}${draft ? '-draft' : ''}.pdf`;
}

export async function makePackPdf(model, { onlyConfirmed = false } = {}) {
  const [{ jsPDF }, { makePdf }] = await Promise.all([import('jspdf'), import('@/canvas/pdf')]);
  return makePdf(model, { jsPDF, onlyConfirmed });
}

// returns true when the file was handed to the browser
export async function downloadPackPdf(model, learner, { onlyConfirmed = false } = {}) {
  const doc = await makePackPdf(model, { onlyConfirmed });
  const name = pdfFileName(learner, onlyConfirmed);
  try {
    doc.save(name);
    return true;
  } catch {
    const url = doc.output('bloburl');
    window.open(url, '_blank');
    return true;
  }
}
